{
  "title": "Mga serbisyo",
  "lead": "Mga requirement, hakbang at bayarin ng bawat tanggapan, at ang mga serbisyong maaaring i-apply online.",
  "search": "Maghanap ng serbisyo",
  "office": "Tanggapan",
  "allOffices": "Lahat ng tanggapan",
  "onlyOnline": "Maaaring i-apply online",
  "noMatch": "Walang serbisyong tugma sa hinanap mo.",
  "emptyTitle": "Wala pang nakalistang serbisyo",
  "emptyBody": "Idinadagdag pa ng mga tanggapan ang kanilang mga serbisyo dito. Pansamantala, pumunta o tumawag sa tanggapan.",
  "seeOffices": "Tingnan ang mga tanggapan at contact",
  "class_simple": "Simple",
  "class_complex": "Complex",
  "class_highly_technical": "Highly technical",
  "upToDays": "hanggang {count} araw ng trabaho",
  "applyOnlineBadge": "Mag-apply online",
  "limitsTitle": "Takdang oras ng pagproseso (RA 11032)",
  "limitsBody": "Ayon sa Ease of Doing Business Act, kailangang tapusin ng tanggapan ang serbisyo sa loob ng mga araw ng trabahong ito, mula nang makumpleto ang iyong mga requirement.",
  "limitsUnit": "Araw ng trabaho. Hindi kasama ang Sabado, Linggo at holiday.",
  "noRequirements": "Hindi pa naglilista ng requirement ang tanggapan. Magtanong muna bago pumunta.",
  "whereToSecure": "Saan kukunin: {place}",
  "noSteps": "Hindi pa naglilista ng mga hakbang ang tanggapan.",
  "colClient": "Ang gagawin mo",
  "colAgency": "Ang gagawin ng tanggapan",
  "colFees": "Bayad",
  "colTime": "Oras",
  "colResponsible": "Taong responsable",
  "stepN": "Hakbang {n}",
  "stepsCaption": "Mga hakbang para sa {name}",
  "backToServices": "Lahat ng serbisyo",
  "notFound": "Hindi available ang serbisyong ito. Maaaring tinanggal na ito ng tanggapan.",
  "shareText": "Mula sa {office} sa {app}",
  "applyOnline": "Mag-apply online",
  "applyAtOffice": "Mag-apply nang personal sa {office}.",
  "downloadForm": "I-download ang form",
  "whoMayAvail": "Sino ang maaaring mag-apply",
  "requirements": "Mga requirement",
  "steps": "Mga hakbang",
  "feesAndTime": "Bayad at tagal ng pagproseso",
  "fees": "Bayad",
  "feesNotStated": "Hindi pa nakasaad. Magtanong sa tanggapan.",
  "processingTime": "Tagal ng pagproseso",
  "timeNotStated": "Hindi pa nakasaad.",
  "maxTime": "Pinakamatagal ayon sa batas",
  "maxTimeValue": "{count} araw ng trabaho ({class})",
  "ra11032Short": "Itinatakda ng RA 11032 (Ease of Doing Business Act) ang pinakamatagal na pagproseso. Binibilang ito mula nang makumpleto ang iyong mga requirement.",
  "whereToGo": "Saan pupunta",
  "location": "Lokasyon",
  "hours": "Oras ng opisina",
  "email": "Mag-email",
  "rate": "I-rate ang serbisyong ito",
  "civilRegistryTitle": "Civil Registry",
  "civilRegistryLead": "Mga kopya ng rekord ng kapanganakan, kasal at kamatayan, at iba pang serbisyo ng civil registry.",
  "localOrPsaTitle": "Lokal na kopya o kopya mula sa PSA?",
  "localOrPsaBody": "Ang Municipal Civil Registry ay nagbibigay ng certified na kopya ng mga rekord na nakarehistro sa {lgu}. Ang mga kopyang certified ng PSA, na madalas kailangan sa pasaporte at visa, ay mula sa Philippine Statistics Authority (PSA).",
  "civilEmptyTitle": "Wala pang serbisyo ng civil registry sa app",
  "civilEmptyBody": "Hindi pa naglalagay ng serbisyo dito ang Civil Registry. Pumunta o tumawag sa tanggapan.",
  "charterTitle": "Citizen's Charter",
  "charterLead": "Ang kailangan ng bawat serbisyo ng {lgu}, gaano katagal, magkano, at sino ang responsable.",
  "charterEmptyTitle": "Inihahanda pa ang charter",
  "charterEmptyBody": "Idinadagdag pa ng mga tanggapan ang kanilang mga serbisyo. Nakapaskil din ang Citizen's Charter sa counter ng bawat tanggapan.",
  "openService": "Buksan ang pahina ng serbisyo",
  "staffLead": "Ang mga serbisyo ng inyong tanggapan. Lumalabas ang mga ito sa Citizen's Charter, at maaaring mag-apply online ang mga residente sa mga binuksan ninyo.",
  "viewCharter": "Tingnan ang pampublikong charter",
  "newService": "Bagong serbisyo",
  "editService": "I-edit ang serbisyo",
  "staffEmptyTitle": "Wala pang serbisyo",
  "staffEmptyBody": "Idagdag ang bawat serbisyo ng inyong tanggapan: mga requirement, hakbang, bayad at tagal ng pagproseso. Ito ang magiging Citizen's Charter ninyo sa app.",
  "hidden": "Nakatago",
  "hide": "Itago",
  "show": "Ipakita",
  "hiddenToast": "Nakatago na sa mga residente ang {name}.",
  "shownToast": "Nakikita na ng mga residente ang {name}.",
  "reqCount": "Mga requirement: {count}",
  "moveUp": "Iakyat ang {name}",
  "moveDown": "Ibaba ang {name}",
  "removeItem": "Alisin ang {name}",
  "editorLead": "Isulat ito gaya ng nasa inyong Citizen's Charter. Ito ang nakikita ng mga residente bago pumunta sa inyong tanggapan.",
  "viewPublic": "Tingnan ang pampublikong pahina",
  "sectionBasics": "Tungkol sa serbisyo",
  "name": "Pangalan ng serbisyo",
  "nameHint": "Ayon sa pagkakakilala ng mga residente, hal. \"Barangay clearance\".",
  "description": "Maikling paglalarawan",
  "descriptionHint": "Isa o dalawang pangungusap: ano ang makukuha ng residente.",
  "whoHint": "hal. \"Mga residente ng munisipyo, 18 taong gulang pataas\".",
  "sectionClass": "Klasipikasyon",
  "classLegend": "Gaano kakomplikado ang serbisyong ito? (RA 11032)",
  "classHint": "Itinatakda ng batas ang pinakamatagal na pagproseso sa bawat klase. Sinusubaybayan dito ang mga online request.",
  "requirementsHint": "Ang dapat dalhin o i-upload ng residente. Isulat kung saan kukunin kung galing sa ibang tanggapan.",
  "requirementN": "Requirement {n}",
  "reqLabel": "Requirement",
  "reqWhere": "Saan kukunin",
  "reqNote": "Paalala",
  "addRequirement": "Magdagdag ng requirement",
  "stepsHint": "Ang proseso ayon sa inyong charter: ang gagawin ng kliyente, ang gagawin ng tanggapan, bayad, oras at taong responsable.",
  "timePlaceholder": "hal. 10 minuto",
  "addStep": "Magdagdag ng hakbang",
  "feesTotal": "Kabuuang bayad",
  "feesHint": "hal. \"₱50 certification fee\" o \"Ayon sa Revenue Code, Sec. 12\".",
  "timeTotal": "Kabuuang tagal ng pagproseso",
  "timeHint": "Gaya ng nasa inyong charter, hal. \"1 araw, 2 oras\".",
  "sectionOnline": "Online na aplikasyon",
  "onlineToggle": "Maaaring mag-apply online ang mga residente",
  "onlineHint": "Pumapasok ang mga request sa listahan ng Mga request ng inyong tanggapan, may reference number at deadline ayon sa RA 11032.",
  "onlineNote": "Laging tinatanong ang buong pangalan ng aplikante. May kasama ring pahintulot sa ilalim ng Data Privacy Act ang bawat form; hindi na ito kailangang idagdag.",
  "sectionForm": "Form na mada-download",
  "formHint": "Opsyonal. PDF ng inyong application form o gabay na maaaring i-print ng mga residente.",
  "uploadForm": "Mag-upload ng PDF",
  "uploading": "Ina-upload…",
  "sectionVisibility": "Pagkakita",
  "activeToggle": "Ipakita sa app",
  "activeHint": "Nananatiling naka-save ang mga nakatagong serbisyo pero hindi lumalabas sa Mga serbisyo o sa charter.",
  "savedToast": "Na-save ang serbisyo.",
  "filteredByCapability": "Ipinapakita ang mga serbisyo ng mga opisinang humahawak nito.",
  "showAllServices": "Ipakita ang lahat ng serbisyo"
}
